"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundPurchaseInitRequest = void 0;
var FundPurchaseInitRequest = /** @class */ (function () {
    function FundPurchaseInitRequest() {
    }
    return FundPurchaseInitRequest;
}());
exports.FundPurchaseInitRequest = FundPurchaseInitRequest;
;
//# sourceMappingURL=fundPurchaseInit.request.js.map